import infoIcon from "@assets/images/small-info.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    root: {
      background: "white",
      padding: "20px 0",
      textAlign: "center",
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: 6
    },
    wrapper: {
      width: 320,
      margin: "0 auto"
    },
    textWrapper: {
      marginBottom: 21,
      display: "flex",
      justifyContent: "center"
    },
    icon: {
      marginRight: 10
    },
    btn: {
      width: "100%"
    }
  }),
  {
    name: "EmptyCartTable"
  }
);
interface EmptyCartTableProps {
  message?: string;
  onBack?: () => void;
}
const EmptyCartTable: React.FC<EmptyCartTableProps> = ({ message, onBack }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <div className={classes.textWrapper}>
          <SVG src={infoIcon} className={classes.icon} />
          <MyTypography variant="body2">
            <FormattedMessage defaultMessage="ตะกร้าช้อปปิ้งของคุณ ยังไม่มีสินค้า" />
          </MyTypography>
        </div>
        <Button
          variant="contained"
          color="secondary"
          className={classes.btn}
          onClick={onBack}
          name="back-search-button"
          id="back-search-button"
        >
          {message ? (
            message
          ) : (
            <FormattedMessage defaultMessage="ไปหน้า Search เพื่อทำรายการ" />
          )}
        </Button>
      </div>
    </div>
  );
};

export default EmptyCartTable;
